export const MessageType = {
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  WEB: "web",
  WHATSAPP: "whatsapp",
  LINKEDIN: "linkedin",
  LINKEDIN_BUSINESS: "linkedinBusiness",
};
